import { ErrorSmallPopup } from '../../popups/errorSmallPopup';
import { Localization } from '../../localization/localization';
import { exposeLoginHandlerFunctions } from '../../login/common';
import { loadAccountWindow } from '../../account-window/account-window-loader';
import { container } from '../../utils/container/container';
import { FeatureFlagsLoader } from '../../utils/feature-flags/feature-flags-loader';
import { ServiceIds } from '../../utils/container/service-ids';
import { FlagNames } from '../../utils/feature-flags/flag-names';

export class WebGuestWarningPopup {
    static showNotifications() {
        if (window.app.config.hasGuestAuthMethod) {
            exposeLoginHandlerFunctions();
        }

        WebGuestWarningPopup.showWebGuestAccountWarning();
    }

    public static showWebGuestNotificationWindow(): void {
        if (!window.app.config.hasGuestAuthMethod) {
            return;
        }

        const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
        const disableFlag = ffLoader.get(FlagNames.DISABLE_WEB_GUEST_ACCOUNT_WARNING);
        if (disableFlag.isOn()) {
            return;
        }

        const text = Localization._n('account.web_guest.danger');
        const errorPopup = this.createNotificationWindow(text);
        errorPopup.show();
    }

    private static createNotificationWindow(body: string): ErrorSmallPopup {
        const connectToAccount = Localization._n('account.web_guest.connect_account');
        const connectToAccountTitle = Localization._n('account.web_guest.connect_account_title');
        const errorPopup = ErrorSmallPopup.getInstance();
        errorPopup.enableCloseBtn();
        errorPopup.setTitle(connectToAccountTitle);
        errorPopup.setButtonText(connectToAccount);
        errorPopup.setMessage(body, true);
        errorPopup.setCallback(loadAccountWindow);

        return errorPopup;
    }

    private static showWebGuestAccountWarning() {
        if (window.app.config.hasGuestAuthMethod) {
            $('.tether_social_account.error_icon').removeClass('mount-hidden');
        }
    }
}
